<template>
  <section>

    <v-container fluid>
      <v-data-table
          dense
          :headers="headers"
          :items="reviews"
          class="elevation-2"
      >
        <template v-slot:item.session_id="{value}">
          <v-btn x-small color="primary" target="_blank" :to="{name: 'Session', params: { session_id: value }}">open</v-btn>
        </template>
        <template v-slot:item.reviewer_id="{value}">
          <v-btn x-small color="primary" target="_blank" :to="{name: 'Student', params: { student_id: value }}">open</v-btn>
        </template>
        <template v-slot:item.actions="{item}">
          <v-btn x-small color="primary" @click="openSelectedItemDialog(item)">
            <v-icon>mdi-cog</v-icon>
          </v-btn>
        </template>
      </v-data-table>

    </v-container>


    <v-dialog v-model="selected_item_dialog" @click:outside="closeSelectedItemDialog" max-width="500px">
      <v-card v-if="selected_item">
        <v-toolbar dark dense color="primary">Edit <v-spacer/>
          <v-btn icon @click="closeSelectedItemDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pt-3">
          <v-textarea v-model="selected_item.body" outlined hide-details></v-textarea>
        </v-card-text>

        <v-card-actions class="justify-space-between">
          <v-btn color="error" @click="deleteSelectedItem">Delete</v-btn>
          <v-btn color="primary" @click="updateSelectedItem">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </section>
</template>

<script>

export default {
  props: {
    mock: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    reviews: [],
    headers: [
      { text: 'ID', value: 'id' },
      { text: 'Rating', value: 'rating' },
      { text: 'Review', value: 'body' },
      { text: 'Session', value: 'session_id' },
      { text: 'Reviewer', value: 'reviewer_id' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    selected_item: null,
    selected_item_dialog: false,

    api_errors: []
  }),
  created() {
    this.loadReviews()
  },
  methods: {
    loadReviews() {
      this.axios.get(`api/tutors/${this.$route.params.tutor_id}/reviews`)
          .then(({data}) => {this.reviews = data.data})
    },
    openSelectedItemDialog(item) {
      this.selected_item = item
      this.selected_item_dialog = true
    },
    closeSelectedItemDialog() {
      this.selected_item_dialog = false
      this.selected_item = null
    },
    updateSelectedItem() {
      this.app_loading = true
      this.api_errors = []
      this.axios.put(`api/tutors/${this.$route.params.tutor_id}/reviews/${this.selected_item.id}`, this.selected_item)
          .then(({data}) => {
            console.log(data.data)
            this.closeSelectedItemDialog()
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
          .then(() => {this.app_loading = false})
    },
    deleteSelectedItem() {
      this.axios.delete(`api/tutors/${this.$route.params.tutor_id}/reviews/${this.selected_item.id}`, this.selected_item)
          .then(() => {
            this.closeSelectedItemDialog()
            this.loadReviews()
          })
    },
  }
}
</script>
